<template>
    <DefaultLayout>
        <StaticDeclineHero />

        <div class="container">
            <div class="row">
                <div class="col">
                    <DeclinedLenders :isFraudDecline="true" />
                </div>
            </div>
        </div>
    </DefaultLayout>
</template>

<script>
import { useStore } from 'vuex'

export default {
    setup() {
        const store = useStore()
        return {
            store,
        }
    },
    created() {
        this.trackEvent('fraud_device', { territory: process.env.TERRITORY })
    },
}
</script>
